import { render } from "./tshirts.vue?vue&type=template&id=3774a4c0&scoped=true"
import script from "./tshirts.vue?vue&type=script&lang=js"
export * from "./tshirts.vue?vue&type=script&lang=js"

import "./tshirts.vue?vue&type=style&index=0&id=3774a4c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3774a4c0"]])

export default __exports__